import createRoute from '@widesk-ui/tools/createRoute';

const route = createRoute.customFromService(
	`Statistiques - Daisuki`,
	'/website_entertainments/:websiteEntertainmentId/statistics/daisuki',
	'website',
	'DaisukiStatistic',
);

export default route;
